export default "__VITE_ASSET__DOEI0rc___"